export const TARGETED_RECONCILIATION_PROPS = {
  STATUS_FILTER: {
    PLACEHOLDER: 'Status',
    LABEL: 'Status',
  },
  SEARCH: {
    SOURCE_TRANSACTION_ID_PLACEHOLDER: 'Source Transaction Id (UUID)',
  },
};

export const TARGETED_RECONCILIATION_STATUS_FILTERS = [
  {
    queryParam: 'All',
    name: 'All Status',
  },
  {
    queryParam: 'OPEN',
    name: 'Open',
  },
  {
    queryParam: 'CLOSED',
    name: 'Closed',
  },
  {
    queryParam: 'INPROGRESS',
    name: 'In Progress',
  },
  {
    queryParam: 'FAILED',
    name: 'Failed',
  },
];

export const TARGETED_RECONCILIATION_COLUMNS = {
  PROVIDER_ID: 'Provider Id',
  PARTNER_ID: 'Partner Id',
  OPERATOR_ID: 'Operator Id',
  SOURCE_TRANSACTION_ID: 'Source Transaction Id',
  STATUS: 'Status',
  SALE_DTM: 'Sale Dtm',
  CREATED_ON: 'Created On',
  UPDATED_ON: 'Updated On',
};
